import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = window.location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }
    api
      .post("/auth/session", { session_id: sessionId })
      .then((res) => {
        window.history.replaceState(null, "", window.location.pathname);
        if (res.data.is_admin) {
          navigate("/admin", { state: { user: res.data }, replace: true });
        } else {
          navigate("/admin/login", { state: { error: "not_admin" }, replace: true });
        }
      })
      .catch(() => navigate("/admin/login", { replace: true }));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-navy flex flex-col items-center justify-center gap-6" data-testid="auth-callback-loading">
      <div className="w-8 h-8 border-2 border-gold border-t-transparent rounded-full animate-spin" />
      <p className="font-mono text-xs tracking-[0.3em] text-white/50 uppercase">Signing you in</p>
    </div>
  );
}
